<template>
  <transition name="modal-fade">
    <Modal @close="close">
      <div class="ly_pop_wrap fix">
        <div class="ly_pop_content ly_pop_libr">
          <div class="ly_pop_head">
            <h2>{{ $t('library.createnewmodal.6326') }}</h2>
            <a class="btn_ly_close svg_close" @click="close">
              <span>{{ $t('library.deletemodal.close') }}</span>
            </a>
          </div>
          <div class="ly_inner">
            <div class="editer_libr">
              <p>{{ $t('library.createnewmodal.502') }}</p>
              <div class="editer_form">
                <div class="editer_text_wrap n_line">
                  <input
                    v-model="name"
                    class="editer_input_t"
                    type="text"
                    :placeholder="$t('library.createnewmodal.744')"
                    @keypress.enter="createNew"
                  />
                  <span :class="`${inputState}_subtext`">{{
                    inputSubMsg
                  }}</span>
                </div>
              </div>
            </div>
            <div class="btn_wrap text-center">
              <button type="submit" class="box_btn" @click="createNew">
                저장
              </button>
              <button type="submit" class="box_btn dull" @click="close">
                취소
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </transition>
</template>
<script>
import { BOOKSHELF_CREATE, BOOKSHELF_GET_LIST } from '@/store/types'

export default {
  name: 'CreateNewModal',
  data() {
    return {
      name: '',
      inputState: '',
      inputSubMsg: ''
    }
  },
  computed: {
    baseBookshelves() {
      return this.$store.getters.getBookshelves.filter(
        (e) => e.bookshelfTp !== 'GFT' && e.bookshelfTp !== 'PRS'
      )
    }
  },
  watch: {
    name() {
      this.inputSubMsg = ''
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    async createNew() {
      const { name } = this

      if (name != '') {
        if (this.baseBookshelves.find((e) => e.bookshelfNm === name)) {
          this.inputState = 'error'
          this.inputSubMsg = '이미 동일한 이름의 책장이 있습니다.'
          return
        }
        try {
          console.log('ddd')
          await this.$store.dispatch(BOOKSHELF_CREATE, { name })
          await this.$store.dispatch(BOOKSHELF_GET_LIST)
        } catch (e) {
          console.log(e)
        }
        this.name = ''
        this.close()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.btn_wrap {
  display: flex;
}
.editer_libr + .btn_wrap .box_btn {
  height: 38px;
  font-size: 16px;
  color: #fff;
}
</style>
